import React from 'react';
import PropTypes from 'prop-types';
import { faOutdent } from '@fortawesome/free-solid-svg-icons';
import { CPButton } from './styles';

export function FillInTheTableButton({
  content, title, onClick, disabled,
}) {
  return (
    <CPButton
      onClick={onClick}
      disabled={disabled}
      content={content}
      icon={faOutdent}
      title={title}
    />
  );
}

FillInTheTableButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.string,
};

FillInTheTableButton.defaultProps = {
  onClick: () => null,
  content: '',
  disabled: false,
  title: 'Автоматично заповнити',
};

export default FillInTheTableButton;
